import { useUser } from "src/auth/auth.ts";
import { useDataRouterContext } from "src/lib/react-router/useDataRouterContext.ts";
import { useUserDataState } from "src/user-data/useUserDataState.ts";
import type { ModuleTabsPersistedState } from "src/user-data/types.ts";
import { ModuleLayoutTabsUserDataSchema } from "src/user-data/schemas.ts";
import { sanitazeModuleLayoutTabs } from "src/user-data/sanitazors.ts";
import type { StorageKey } from "@exonn/storage";

export const useGetTabTitle = ({
  storageKey,
  id,
}: {
  id: string;
  storageKey: StorageKey;
}) => {
  const { data: user } = useUser();
  const { router } = useDataRouterContext();

  const { value: userData } = useUserDataState<ModuleTabsPersistedState>({
    key: storageKey,
    validationSchema: ModuleLayoutTabsUserDataSchema,
    sanitaze: sanitazeModuleLayoutTabs(router),
    user: user!,
  });
  const titles = userData?.titles;
  if (!titles) {
    return null;
  }

  return titles[id] ?? null;
};
